import { z } from 'zod';

export const filterSchema = z.object({
  region_id: z.string().min(1, 'Hudud tanlanishi shart'),
  district_id: z.string().optional(),
  plant_id: z.string().min(1, 'Ekin turi tanlanishi shart'),
  action_id: z.array(z.string()).optional(),
});

export type FilterFormValue = z.infer<typeof filterSchema>;
